import { useDownloadInvoice } from '../../../hooks/useDownloadInvoice';
import { useDownloadInvoiceAnonymous } from '../../../hooks/useDownloadInvoiceAnonymous';
import { t } from '../../../services/translation/translation';
import { PrimaryButton } from '../../button/PrimaryButton';

type Props = {
  tripKey: string;
  jwtToken?: string;
};

export const InvoiceDownloadButton = ({ tripKey, jwtToken }: Props) => {
  const { mutate: downloadInvoice, isLoading } = useDownloadInvoice();
  const { mutate: downloadInvoiceAnonymous, isLoading: isLoadingAnonymous } = useDownloadInvoiceAnonymous();

  const handleDownload = (tripKey: string) => {
    if (jwtToken) {
      downloadInvoiceAnonymous({ tripKey, jwtToken });
    } else {
      downloadInvoice(tripKey);
    }
  };

  return (
    <PrimaryButton
      text={t('common.download')}
      className="mr-0 ml-auto"
      onClick={() => handleDownload(tripKey)}
      isLoading={isLoading || isLoadingAnonymous}
    />
  );
};
